import {FC, useEffect, useState} from "react";
import {IoIosArrowForward} from "react-icons/io";
import {useParams} from "react-router-dom";
import {FaHouse, FaHouseSignal} from "react-icons/fa6";
import {FaEdit, FaTrash} from "react-icons/fa";
import PropertyResultPickerModal from "../modal/PropertyResultPickerModal";
import PropertyResponseModel from "../modal/PropertyResponseModel";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import {useUpdatePropertySkipAutomationMutation} from "../productsApi";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";
import {formatBuyerSellerNames} from "../../../helpers/utils/Utils";

interface ProductPricingDetailProps {
    productId?: string | null;
    orderData?: OrderData;
}

interface PropertiesItem {
    attributes: string;
    sequence: number;
    taxIdentifier?: string;
    addressType?: string;
    addressLine1?: string;
    city?: string;
    state?: string;
    zip?: string;
    countyName?: string;
    country?: string;
    legalDescription?: string;
    accountNumber?: string;
    countyData?: string;
    propertyRequestSource?: string
    id: string;
}

interface OrderData {
    data?: any
}



const OrderProperties: FC<ProductPricingDetailProps> = ({ productId, orderData }) => {
    const { orderId } = useParams();
    const [expandedParties, setExpandedParties] = useState<number[]>([]);
    const [propertyResultId, setPropertyResultId] = useState("");
    const [showSkipAutomationConfirmation, setShowSkipAutomationConfirmation] = useState(false);
    const [showPropertiesModel, setShowPropertiesModel] = useState(false);
    const [curProperty, setCurProperty] = useState(null);
    const [showPropertyPickerModel, setShowPropertyPickerModel] = useState(false);
    const [taxAccountNumber, setTaxAccountNumber] = useState("");
    const [state, setState] = useState("");
    const [county, setCounty] = useState("");
    const [address, setAddress] = useState("");
    const [legalDescription, setLegalDescription] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [skipAutomationApi, skipAutomationRes] = useUpdatePropertySkipAutomationMutation();
    const [propertyId, setPropertyId] = useState("");
    const togglePartyCollapse = (id: number) => {
        setExpandedParties((prev) =>
            prev.includes(id) ? prev.filter((partyId) => partyId !== id) : [...prev, id]
        );
    };

    useEffect(() => {
        if (orderData?.data?.properties && orderData?.data?.properties?.length === 1) {
            setExpandedParties(orderData?.data?.properties?.map((_: any, index: any) => index));
        }
    }, [orderData]);

    const skipPropertyForAutomation = async (e: any) => {
        e.preventDefault();
        if (propertyResultId) {
            await skipAutomationApi(propertyResultId);
        }
    }


    return (
        <div className="bg-text-1 mt-3  rounded-md shadow-[0_3px_10px_#0003] text-sm">

            <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                <h5 className="font-semibold text-surface-0">Properties
                    ({orderData?.data?.properties?.length || 0})</h5>
            </div>

            <div className={'p-2'}>
                {orderData?.data?.properties?.map((obj: any, index: any) => (
                    <div key={obj?.id} className={`bg-text-0 ${index === 0 ? "" : "mt-1"}`}>
                        <div className={`col-span-12  ${expandedParties.includes(index) ? "" : ""}`} key={index}>
                            <div
                                className={
                                    `text-lg cursor-pointer ` +
                                    (orderData?.data?.properties?.length === 1
                                        ? (obj.propertyResult === null
                                            ? "bg-surface-5 border-none flex text-error-1"
                                            : obj?.propertyRequestSource === "CERT_ACCOUNT"
                                                ? "!bg-[#d4a8ff] !border-none flex  text-highlight-5"
                                                : "bg-surface-5 border-none flex text-highlight-5")
                                        : (obj.propertyResult === null
                                            ? "bg-surface-5 border-none text-error-1 collapsed"
                                            : obj?.propertyRequestSource === "CERT_ACCOUNT"
                                                ? "!bg-[#d4a8ff] !border-none text-highlight-5  collapsed"
                                                : "bg-surface-5 border-none text-highlight-5  collapsed"))
                                }
                                onClick={() => togglePartyCollapse(index)}>
                                <div className="justify-between flex px-2 py-2  items-center w-full">
                                    <div className="flex items-center gap-3 w-full">
                                        <FaHouse title="Home" size={16}/>
                                        <span className="text-highlight-5 font-semibold text-sm"
                                              style={{textDecoration: obj?.propertyResult !== null && obj?.propertyResult?.skipAutomation ? "line-through" : "none"}}>
                                            {obj?.addressLine1 || "Unknown"}
                                        </span></div>
                                    <div className="flex gap-5 text-highlight-5">
                                        {hasPermission(["PRORESULT-U"]) && (
                                            <>
                                                <FaHouseSignal
                                                    size={16}
                                                    className="cursor-pointer text-md hover:text-text-hover-1"
                                                    title=""
                                                    onClick={() => {
                                                        setTaxAccountNumber(obj.taxIdentifier);
                                                        setAddress(obj.addressLine1);
                                                        setLegalDescription(obj.legalDescription);
                                                        setOwnerName(obj.sellerName);
                                                        setPropertyId(obj.id);
                                                        setShowPropertyPickerModel(true);
                                                        setState(obj.state);
                                                        setCounty(obj.countyName);
                                                    }}
                                                />

                                                <FaEdit
                                                    size={16}
                                                    className="cursor-pointer text-md hover:text-text-hover-1 ml-2 rounded-md"
                                                    title=""
                                                    onClick={() => {
                                                        setCurProperty(obj);
                                                        setShowPropertiesModel(true);
                                                    }}
                                                />

                                                <FaTrash
                                                    className="ml-2"
                                                    size={14}
                                                    style={{
                                                        pointerEvents:
                                                            obj?.propertyResult === null ||
                                                            obj?.propertyResult?.skipAutomation ||
                                                            obj?.propertyRequestSource === "CERT_ACCOUNT" ||
                                                            obj.associatedWithAccount
                                                                ? "none"
                                                                : "auto",
                                                        color:
                                                            obj?.propertyResult === null ||
                                                            obj?.propertyResult?.skipAutomation ||
                                                            obj?.propertyRequestSource === "CERT_ACCOUNT" ||
                                                            obj.associatedWithAccount
                                                                ? "gray"
                                                                : "#4682b4",
                                                    }}
                                                    title="Skip automation for this property"
                                                    onClick={() => {
                                                        if (obj.propertyResult !== null) {
                                                            setPropertyResultId(obj.propertyResult.id);
                                                            setShowSkipAutomationConfirmation(true);
                                                        }
                                                    }}
                                                />
                                            </>
                                        )}

                                        <IoIosArrowForward
                                            className={`text-lg cursor-pointer ${expandedParties.includes(index) ? "rotate-90" : ""}`}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Expanded Details */}
                        {expandedParties.includes(index) && (
                            <div className="mt-3 rounded-lg overflow-hidden text-sm">
                                {/* Header Row */}
                                <div className="grid grid-cols-3 bg-gray-100 font-semibold text-left">
                                    <div className="p-2"></div>
                                    <div className="p-2">Request</div>
                                    <div className="p-2">Result</div>
                                </div>

                                {/* Data Rows */}
                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Address</div>
                                    <div className="p-2">{obj.addressLine1 || '-'}</div>
                                    <div className="p-2">{obj?.propertyResult?.address || '-'}</div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Legal Description</div>
                                    <div className="p-2">{obj.legalDescription || '-'}</div>
                                    <div className="p-2">{obj?.propertyResult?.legalDescription || '-'}</div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Subdivision</div>
                                    <div className="p-2">{obj.subdivision || '-'}</div>
                                    <div className="p-2">{obj?.propertyResult?.subdivisionName || '-'}</div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">County</div>
                                    <div className="p-2">{obj?.countyName || '-'}, {obj?.state || '-'}</div>
                                    <div className="p-2">
                                        {obj?.propertyResult?.parsedAddress?.county && obj?.propertyResult?.parsedAddress?.state
                                            ? `${obj.propertyResult.parsedAddress.county}, ${obj.propertyResult.parsedAddress.state}`
                                            : '-'}
                                    </div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Seller Name</div>
                                    <div className="p-2">{formatBuyerSellerNames(orderData.data.sellerName)}</div>
                                    <div
                                        className="p-2">{[obj?.propertyResult?.primaryOwner, obj?.propertyResult?.secondaryOwner].filter(Boolean).join(', ')}</div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Buyer Name</div>
                                    <div className="p-2">{formatBuyerSellerNames(orderData.data.buyerName) || '-'}</div>
                                    <div className="p-2">-</div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Property Type</div>
                                    <div className="p-2">{obj?.addressType || '-'}</div>
                                    <div className="p-2">{obj?.propertyResult?.addressType || '-'}</div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Source</div>
                                    <div className="p-2">{obj?.propertyRequestSource || '-'}</div>
                                    <div className="p-2">{obj?.propertyResult?.propertyResultSource || '-'}</div>
                                </div>

                                <div className="grid grid-cols-3 border-t border-surface-5">
                                    <div className="p-2 font-semibold">Account No</div>
                                    <div className="p-2">{obj?.accountNumber || '-'}</div>
                                    <div className="p-2">{obj?.propertyResult?.taxId || '-'}</div>
                                </div>
                            </div>


                        )}
                    </div>

                ))}
            </div>
            {
                showPropertyPickerModel &&
                <PropertyResultPickerModal show={showPropertyPickerModel} setShow={setShowPropertyPickerModel}
                                           orderData={orderData}
                                           taxAccountNumber={taxAccountNumber}
                                           setTaxAccountNumber={setTaxAccountNumber} address={address}
                                           setAddress={setAddress}
                                           legalDescription={legalDescription}
                                           setLegalDescription={setLegalDescription}
                                           ownerName={ownerName}
                                           setOwnerName={setOwnerName}
                                           orderId={orderId}
                                           propertyId={propertyId}
                                           state={state}
                                           county={county}
                />
            }
            {
                showPropertiesModel &&
                <PropertyResponseModel show={showPropertiesModel} setShow={setShowPropertiesModel}
                                       propertyData={curProperty} orderData={orderData} setPropertyData={setCurProperty}
                />
            }
            {showSkipAutomationConfirmation &&
                <ConfirmationModal title={"Skip automation for this property"}
                                   bodyMessage={"Are you sure you want to skip automation for this property?"}
                                   onSubmit={skipPropertyForAutomation}
                                   show={showSkipAutomationConfirmation}
                                   setShow={setShowSkipAutomationConfirmation}
                                   isLoading={skipAutomationRes.isLoading}
                />
            }
        </div>
    );
};

export default OrderProperties;
